// VerificationPermits
export default {
  approveBuyServiceProduct(permissions) {
    if (!permissions) {
      return false
    }

    return (
      permissions.roles.particulars.approve ||
      permissions.roles.affiliate.approve ||
      permissions.roles.consumers.approve ||
      permissions.roles.renewableEnergyProducers.approve ||
      permissions.roles.particularProsumer.approve ||
      permissions.roles.industrialProsumer.approve ||
      permissions.roles.carbonEnergyGeneratior.approve
    )
  },

  requestBuyServiceProduct(permissions) {
    if (!permissions) {
      return false
    }

    return (
      permissions.roles.particulars.request ||
      permissions.roles.affiliate.request ||
      permissions.roles.consumers.request ||
      permissions.roles.renewableEnergyProducers.request ||
      permissions.roles.particularProsumer.request ||
      permissions.roles.industrialProsumer.request ||
      permissions.roles.carbonEnergyGeneratior.request
    )
  },

  approveRegistrationExistingProject(permissions) {
    if (!permissions) {
      return false
    }

    return (
      permissions.roles.renewableEnergyProducers.approve ||
      permissions.roles.particularProsumer.approve ||
      permissions.roles.industrialProsumer.approve ||
      permissions.roles.carbonEnergyGeneratior.approve
    )
  },

  requestRegistrationExistingProject(permissions) {
    if (!permissions) {
      return false
    }

    return (
      permissions.roles.renewableEnergyProducers.request ||
      permissions.roles.particularProsumer.request ||
      permissions.roles.industrialProsumer.request ||
      permissions.roles.carbonEnergyGeneratior.request
    )
  },

  approveTradeOffCO2(permissions) {
    if (!permissions) {
      return false
    }

    return (
      permissions.roles.consumers.approve ||
      permissions.roles.renewableEnergyProducers.approve ||
      permissions.roles.particularProsumer.approve ||
      permissions.roles.industrialProsumer.approve ||
      permissions.roles.carbonEnergyGeneratior.approve
    )
  },

  requestTradeOffCO2(permissions) {
    if (!permissions) {
      return false
    }

    return (
      permissions.roles.consumers.request ||
      permissions.roles.renewableEnergyProducers.request ||
      permissions.roles.particularProsumer.request ||
      permissions.roles.industrialProsumer.request ||
      permissions.roles.carbonEnergyGeneratior.request
    )
  },
}



// WEBPACK FOOTER //
// ./src/services/permissions.js